import { useMutation } from '@tanstack/react-query';

import { QuestionnairesApi } from 'api';
import { FI_TASK_KEY } from 'hooks/keys';
import { useUser } from 'hooks/queries/useUser';
import { useFiTaskCache } from '../useFiTaskCache';

interface DeleteDistributionParams {
  taskIds: string[];
  templateId: string;
  sentOn: string;
  dueDate: string;
  reoccurring: boolean;
}

/** Deletes every questionnaire sent out by a single distribution. */
export function useDeleteBulkDistributedQuestionnaires() {
  const { userBankId } = useUser();
  const { invalidateTaskDetails, invalidateTaskLists } = useFiTaskCache();
  const questionnairesApi = new QuestionnairesApi();

  const {
    mutateAsync: deleteBulkDistributedQuestionnaires,
    isPending: isDeleteBulkDistributedQuestionnairesPending
  } = useMutation({
    mutationKey: [FI_TASK_KEY],
    mutationFn: ({ templateId, sentOn, dueDate, reoccurring }: DeleteDistributionParams) =>
      questionnairesApi.deleteBulkDistributedQuestionnaires(
        userBankId,
        templateId,
        sentOn,
        dueDate,
        reoccurring
      ),
    onSuccess: (_, { taskIds }) => {
      invalidateTaskLists();
      invalidateTaskDetails(taskIds);
    },
    meta: {
      snackbarSuccessMessage: 'Distributed questionnaire has been successfully deleted.',
      snackbarErrorMessage:
        'There was an issue deleting the Questionnaires. Please verify it still exists or try again later.'
    }
  });

  return { deleteBulkDistributedQuestionnaires, isDeleteBulkDistributedQuestionnairesPending };
}
